import { all } from 'redux-saga/effects';
import { unfixedConcat } from '../../../utils';
import { mapSagasFromConfigurations } from '../../helpers/sagas';
import { configurations, getDataConfigurations } from './configurations';

function* userSagas() {
  yield all(
    unfixedConcat(
      mapSagasFromConfigurations('user')(configurations),
      mapSagasFromConfigurations('getData')(getDataConfigurations)
    )
  );
}

export default userSagas;



// WEBPACK FOOTER //
// ./src/state/modules/user/sagas.js